import {
  AuthActionStack,
  AuthPageContainer,
} from '@affine/component/auth-components';
import type { GetInviteInfoQuery } from '@affine/graphql';
import { useI18n } from '@affine/i18n';
import { BRAND_DISPLAY_NAME } from '@streamlain/brand';
import type { ReactNode } from 'react';

import { Button } from '../../ui/button';
import { InviteSummary } from './invite-summary';
import * as styles from './styles.css';

export const AcceptInvitePage = ({
  onOpenWorkspace,
  inviteInfo,
  journey,
}: {
  onOpenWorkspace: () => void;
  inviteInfo: GetInviteInfoQuery['getInviteInfo'];
  journey?: ReactNode;
}) => {
  const t = useI18n();
  return (
    <AuthPageContainer
      visual="brand"
      title={t['Successfully joined!']()}
      subtitle={BRAND_DISPLAY_NAME}
    >
      <div className={styles.inviteCardBody}>
        <InviteSummary inviteInfo={inviteInfo} />
      </div>
      <div className={styles.inviteActionArea}>
        <AuthActionStack progress={journey}>
          <Button
            className={styles.invitePrimaryButton}
            variant="primary"
            size="extraLarge"
            onClick={onOpenWorkspace}
          >
            {t['Visit Workspace']()}
          </Button>
        </AuthActionStack>
      </div>
    </AuthPageContainer>
  );
};
